import { State } from "../../client";

interface Props {
  state: State<boolean>;
}

export function CheckboxInput({ state: [value, setValue] }: Props) {
  return (
    <input
      type="checkbox"
      checked={value}
      onChange={(e) => setValue(e.target.checked)}
    />
  );
}
